import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Avatar } from "flowbite-react";
import { InstantSearch, Hits, Highlight, Configure } from "react-instantsearch";
import { searchClient } from "../../config/algolia";
import {
  NavBar,
  SideNav,
  Breadcrumb,
  AlgoliaSearchField,
  Tag,
  UserProfile,
} from "../../components";
import { getUserByEmail, setSelectedUser, getUserApplications } from "../../redux/slices/users";

const ListUser = () => {
  const dispatch = useDispatch();
  const { user, loading } = useSelector((state) => state.users);
  const [showSearchResult, setShowSearchResult] = useState(false);

  const handleUserSelected = async (user) => {
    setSelectedUser(user);
    try {
      const response = await dispatch(
        getUserByEmail({ userEmail: user.email })
      );
      const fetchedUser = response.payload.user;
      if (!fetchedUser) return;
      setSelectedUser(fetchedUser);
      // Fetch user applications
      await dispatch(getUserApplications({ userId: fetchedUser.id }));
    } catch {}
  };

  const Hit = ({ hit }) => {
    return (
      <div
        className="border-b w-full cursor-pointer hover:bg-gray-50 dark:bg-gray-800 dark:hover:bg-gray-900"
        onClick={() => {
          handleUserSelected(hit);
        }}
      >
        <th
          scope="row"
          className="flex items-center px-6 py-4 text-gray-900 whitespace-nowrap dark:text-white"
        >
          <Avatar alt="User settings" img={hit.profileImage} rounded />
          <div className="ps-3">
            <div className="text-base font-semibold">
              <Highlight attribute="fullName" hit={hit} />
              <Tag text={hit.userType} type={hit.userType} className="ml-2" />
            </div>
            <div className="font-normal text-gray-500">
              <Highlight attribute="email" hit={hit} />
            </div>
          </div>
        </th>
      </div>
    );
  };

  return (
    <InstantSearch searchClient={searchClient} indexName="users">
      <div className="antialiased bg-gray-50 dark:bg-gray-900">
        <NavBar />
        <SideNav />

        <main className="p-4 md:ml-64 h-auto pt-20">
          <div className="sticky top-14 z-20 bg-gray-50 dark:bg-gray-900">
            <Breadcrumb />
            <Configure hitsPerPage={3} />
            <AlgoliaSearchField
              onFocus={(text) => {
                setShowSearchResult(text.length > 0);
              }}
              onChange={(text) => {
                setShowSearchResult(text.length > 0);
              }}
              onBlur={(text) => {
                setShowSearchResult(false);
              }}
            />
          </div>
          {showSearchResult && (
            <div className="max-w-md mx-auto rounded-lg bg-white dark:bg-gray-800 shadow mt-4 z-10 fixed top-29 left-30">
              <Hits hitComponent={Hit} classNames="w-full" />
            </div>
          )}
          {(user || loading) && <UserProfile user={user} loading={loading} />}
        </main>
      </div>
    </InstantSearch>
  );
};

export default ListUser;
